import { Component } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
    title = 'Acerca de:';
    p1 =
        'La aplicación informática Cexveg, tiene como objetivo la gestión y tramitación de las Solicitudes de Inspección Fitosanitaria de vegetales y productos vegetales en los Puntos de Inspección Fronterizos. Este procedimiento administrativo está regulado por el R(UE) 2016/2031, de 26 de octubre, relativo a las medidas de protección contra las plagas de los vegetales.';
    p2 =
        'Cexveg es propiedad del Ministerio de Agricultura, Pesca y Alimentación, habiendo sido desarrollada por Tragsatec S.A. por encargo de la Subdirección General de Acuerdos Sanitarios y Control en Frontera perteneciente a la Dirección General de Sanidad de la Producción Agraria.';
}
